// extracted by mini-css-extract-plugin
module.exports = {"textarea":"textarea_textarea__2CD4y"};